import { createAction, createSlice } from "@reduxjs/toolkit";

const getMyPurchasesSlice = createSlice({
  name: "getMyPurchases",
  initialState: {
    data: [],
    pagination: {},
    processing: false,
  },
  reducers: {
    pending(state, action) {
      state.processing = true;
      /* TODO: reducer for pending*/
    },
    success(state, action) {
      const { data, pagination } = action.payload;
      state.data = data.data;
      state.pagination = pagination;
      state.processing = false;
      /* TODO: reducer for success*/
    },
    failure(state, action) {
      state.processing = false;
      /* TODO: reducer for failure*/
    },
  },
});

const { name, actions, reducer } = getMyPurchasesSlice;
const getMyPurchasesAction = createAction(name);

export {
  getMyPurchasesAction,
  actions as getMyPurchasesActions,
  reducer as getMyPurchasesReducer,
};
